// extracted by mini-css-extract-plugin
module.exports = {"filters":"styles_filters__2fXTb"};